import { Order } from "@/types";
import { useGetDeviationsByOrderId } from "@/services/Orders";
import NewDeviation from "./NewDeviation/NewDeviation";
import ViewDeviation from "./ViewDeviation/ViewDeviation";

interface DeviationsTabContentProps {
  order: Order;
}

const DeviationsTabContent = ({ order }: DeviationsTabContentProps) => {
  const { data: orderDeviations } = useGetDeviationsByOrderId(order.id);
  // Deviations registered in a receiving inspection show with the inspection instead.
  const manualDeviations = orderDeviations?.filter((deviation) => !deviation.inspectionId) ?? [];

  return (
    <>
      <NewDeviation order={order} />
      {manualDeviations.length > 0 && <ViewDeviation deviations={manualDeviations} />}
    </>
  );
};

export default DeviationsTabContent;
